<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title>
        Histórico de Candidaturas
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="historicoCandidaturas"
        :loading="loadingHistorico"
        :search="search"
        loading-text="Carregando candidaturas..."
        no-data-text="Nenhuma candidatura encontrada"
      >
        <template v-slot:[`item.dataCriacao`]="{ item }">
          {{ formatarData(item.dataCriacao) }}
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-chip :color="getColor(item.status)" dark small>
            {{ getStatus(item.status) }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "HistoricoCandidaturas",
  data() {
    return {
      search: "",
      headers: [
        { text: "ID", value: "id" },
        { text: "Vaga", value: "titulo" },
        { text: "Data Aplicação", value: "dataCriacao" },
        { text: "Status", value: "status" },
        { text: "Observação", value: "observacao" },
      ],
    };
  },
  computed: {
    ...mapGetters("candidaturainterna", [
      "historicoCandidaturas",
      "loadingHistorico",
    ]),
  },
  created() {
    this.carregarHistoricoCandidaturas();
  },
  methods: {
    ...mapActions("candidaturainterna", ["carregarHistoricoCandidaturas"]),
    formatarData(data) {
      if (!data) return "";
      const d = new Date(data);
      if (isNaN(d.getTime())) return data;
      return d.toLocaleDateString("pt-BR");
    },
    getStatus(status) {
      switch (status) {
        case 1:
          return "Nova";
        case 9:
          return "Cancelada";
        default:
          return status;
      }
    },
    getColor(status) {
      switch (status) {
        case 1:
          return "green";
        case 9:
          return "red";
        default:
          return "grey";
      }
    },
  },
};
</script>
